import { ContextMenuItem } from "@/components/ui/context-menu";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import {
  ThreadActionTarget,
  useThreadActions,
} from "@/app/Threads/hooks/useThreadActions";

/**
 * The thread actions as context menu items, so a right click on a row offers
 * what the open thread's header does.
 */
export function ThreadActionMenuItems({
  thread,
}: {
  thread: ThreadActionTarget;
}) {
  const getActions = useThreadActions();
  const { isAdmin } = useTenant();

  const actions = getActions(thread)
    .flatMap((group) => group.items)
    .flatMap((item) => item.actions)
    .filter((action) => !action.isHidden)
    .filter((action) => !action.isAdminAction || isAdmin);

  return (
    <>
      {actions.map((action) => (
        <ContextMenuItem
          key={action.label}
          onSelect={() => {
            void action.handleAction();
          }}
        >
          {action.Icon ? (
            <action.Icon className="size-4 text-gray-500" />
          ) : null}
          {action.label}
        </ContextMenuItem>
      ))}
    </>
  );
}
